import { devEnv } from './dev';
import { prodEnv } from './prod';
import { stageEnv } from './stage';

type TBaseUrlService = 'notification';

export const getBaseUrl = (service: TBaseUrlService): string => {
  const requestOrigin = window.location.origin;
  const prodSubdomainRegEx = /https?:\/\/([a-z0-9]+[.])*seinterminal[.]com/g;

  const stagingSubdomainRegEx = /https?:\/\/([a-z0-9]+[.])*sagetechnologypartners[.]com/g;

  const devSubdomainRegEx = /https?:\/\/([a-z0-9]+[.])*lvh[.]me/g;

  if (prodSubdomainRegEx.test(requestOrigin)) {
    return prodEnv.baseUrl[service];
  } else if (stagingSubdomainRegEx.test(requestOrigin)) {
    return stageEnv.baseUrl[service];
  } else if (devSubdomainRegEx.test(requestOrigin)) {
    return devEnv.baseUrl[service];
  } else {
    return prodEnv.baseUrl[service];
  }
};
